import { Common } from './common.js';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { httpsCallable } from 'firebase/functions';
import photoicon from './images/photoicon.png';
import photoaddicon from './images/photoaddicon.png';
export class ImageUpload {
    static init() {
        ImageUpload.uploadPhotoFunc = Common.env == "dev" /* Environments.dev */ ? null : httpsCallable(Common.firebase.functions, 'uploadPhoto');
        ImageUpload.createProductThumbnailFunc = Common.env == "dev" /* Environments.dev */ ? null : httpsCallable(Common.firebase.functions, 'createProductThumbnail');
    }
    static buildImageUploadDiv() {
        const div = document.getElementById('imageUploadDiv');
        if (div && div.innerHTML == '')
            div.innerHTML = `
<div id="imageUploadingDiv">
    <button class="warn" onclick="lib.imageUploadClose()" style="float: right;">x</button>
    <span>${Common.res.lblImageUrl}</span><br />
    <input id="imageUploadUrl" type="text" onchange="lib.photoOnChange('imageUploadUrl')" /><br />
    <img id="img_imageUploadUrl" style="width: 200px;" /><br />
    <div id="imageUploadAction">
        <button id="imageUploadBtn" onclick="lib.imageUploadFromUrl()">${Common.res.lblImageUrlUploadButton}</button><br />
        <span>${Common.res.lblOr}</span><br />
        <label id="imageUploadLabel" class="custom-file-upload">
            <input id="imageUploadFile" type="file" value="" onchange="lib.imageUploadFromFile()" />${Common.res.lblImageFile}
        </label>
    </div><br />
    <div id="imageUploadLoader" class="loader" style="display: none;"></div>
</div>`;
    }
    static imageUploadClose() {
        Common.displayElem('imageUploadDiv', false);
    }
    static imageUploadOpen(elemId, elemThumbnailId) {
        const elem = Common.getInputElement(elemId);
        if (!elem)
            return;
        ImageUpload.imageUploadElem = elem;
        ImageUpload.imageThumbnailElem = elemThumbnailId ? Common.getInputElement(elemThumbnailId) : null;
        const imageUploadUrl = Common.getInputElement('imageUploadUrl');
        if (imageUploadUrl)
            imageUploadUrl.value = elem.value;
        const img_imageUploadUrl = Common.getImageElement('img_imageUploadUrl');
        if (img_imageUploadUrl) {
            img_imageUploadUrl.removeAttribute('src');
            if (elem.value)
                img_imageUploadUrl.src = elem.value;
        }
        Common.displayElem('imageUploadDiv', true);
    }
    static async getImageUploadStoragePath(bThumbnail = false) {
        if (bThumbnail && Common.env == "dev" /* Environments.dev */)
            return null;
        if (!ImageUpload.imageUploadElem)
            return null;
        const thumbnail = bThumbnail ? '_thumbnail' : '';
        const id = ImageUpload.imageUploadElem.id.startsWith('prod_') ? (await Common.module("products" /* Modules.products */)).getId
            : ImageUpload.imageUploadElem.id.startsWith('brand_') ? (await Common.module("brands" /* Modules.brands */)).getId
                : ImageUpload.imageUploadElem.id.startsWith('slide_') ? (await Common.module("slides" /* Modules.slides */)).getId
                    : ImageUpload.imageUploadElem.id.startsWith('review_') ? (await Common.module("reviews" /* Modules.reviews */)).getId
                        : ImageUpload.imageUploadElem.id.startsWith('testperfect_') ? (await Common.module("testperfect" /* Modules.testperfect */)).getId
                            : null;
        if (ImageUpload.imageUploadElem && ImageUpload.imageUploadElem.id.startsWith('review_')) {
            if (!id)
                throw new Error(Common.res.errorReviewProductChoose);
            return `review_photo/${id}${thumbnail}_${new Date().getTime()}.jpg`;
        }
        if (!id)
            throw new Error(Common.res.errorNoIdForImageUploadElem + ImageUpload.imageUploadElem.id);
        return `${ImageUpload.imageUploadElem.id}/${id}${thumbnail}.jpg`;
    }
    static async imageUploadFromUrl() {
        if (!ImageUpload.imageUploadElem)
            return;
        const imageUploadUrl = Common.getInputElement('imageUploadUrl');
        if (!imageUploadUrl)
            return;
        const photoUrl = imageUploadUrl.value;
        if (Common.isInStorage(photoUrl) && ImageUpload.imageUploadElem) {
            ImageUpload.imageUploadElem.value = photoUrl;
            Common.photoOnChange(ImageUpload.imageUploadElem.id);
            ImageUpload.imageUploadClose();
            return;
        }
        const reqUrl = photoUrl;
        Common.displayElem('imageUploadLoader', true);
        Common.displayElem('imageUploadAction', false);
        try {
            const storagePath = await ImageUpload.getImageUploadStoragePath();
            if (!storagePath)
                return;
            const storageThumbnailPath = ImageUpload.imageThumbnailElem ? await ImageUpload.getImageUploadStoragePath(true) : null;
            const uploaded = await ImageUpload.uploadImageToStorage(reqUrl, storagePath, storageThumbnailPath);
            ImageUpload.imageUploadElem.value = uploaded.image;
            Common.photoOnChange(ImageUpload.imageUploadElem.id);
            if (ImageUpload.imageThumbnailElem) {
                if (uploaded.thumbnail)
                    ImageUpload.imageThumbnailElem.value = uploaded.thumbnail;
                else
                    alert(Common.res.errorCannotGenerateThumbnail);
            }
            ImageUpload.imageUploadClose();
        }
        catch (e) {
            alert(Common.res.errorImageUploadToStorage + Common.getError(e));
        }
        finally {
            Common.displayElem('imageUploadLoader', false);
            Common.displayElem('imageUploadAction', true);
        }
    }
    static async imageUploadFromFile() {
        if (!ImageUpload.imageUploadElem)
            return;
        const imageUploadFile = Common.getInputElement('imageUploadFile');
        if (!imageUploadFile)
            return;
        if (!imageUploadFile.files || imageUploadFile.files.length < 1)
            return;
        Common.displayElem('imageUploadLoader', true);
        Common.displayElem('imageUploadAction', false);
        try {
            const file = imageUploadFile.files[0];
            const storagePath = await ImageUpload.getImageUploadStoragePath();
            if (!storagePath)
                return;
            const storageThumbnailPath = ImageUpload.imageThumbnailElem ? await ImageUpload.getImageUploadStoragePath(true) : null;
            const imageRef = ref(Common.firebase.storage, storagePath);
            const uploadResult = await uploadBytes(imageRef, file);
            const downloadUrl = await getDownloadURL(uploadResult.ref);
            ImageUpload.imageUploadElem.value = downloadUrl;
            Common.photoOnChange(ImageUpload.imageUploadElem.id);
            if (storageThumbnailPath) {
                if (ImageUpload.createProductThumbnailFunc) {
                    await ImageUpload.createProductThumbnailFunc({ fromStorage: storagePath, toThumbnailStorage: storageThumbnailPath });
                }
                const thumbnailRef = ref(Common.firebase.storage, storageThumbnailPath);
                // const thumbnailResult = await uploadBytes(thumbnailRef, await convertToThumbnail(file));
                // await updateMetadata(thumbnailRef, { contentType: 'image/jpeg' });
                let thumbnailUrl = null;
                try {
                    thumbnailUrl = await getDownloadURL(thumbnailRef);
                }
                catch (e) {
                    console.log(Common.res.errorGetThumbnailUrl + Common.getError(e));
                }
                if (thumbnailUrl) {
                    if (ImageUpload.imageThumbnailElem)
                        ImageUpload.imageThumbnailElem.value = thumbnailUrl;
                }
                else {
                    alert(Common.res.errorCannotGenerateThumbnail);
                }
            }
            ImageUpload.imageUploadClose();
        }
        catch (e) {
            alert(Common.res.errorFileUploadToStorage + Common.getError(e));
        }
        finally {
            imageUploadFile.value = '';
            imageUploadFile.removeAttribute('value');
            Common.displayElem('imageUploadLoader', false);
            Common.displayElem('imageUploadAction', true);
        }
    }
    static async uploadImageToStorage(fromUrl, toStorage, toThumbnailStorage) {
        if (ImageUpload.uploadPhotoFunc) {
            await ImageUpload.uploadPhotoFunc({ fromUrl, toStorage, toThumbnailStorage });
        }
        const imageRef = ref(Common.firebase.storage, toStorage);
        const downloadUrl = await getDownloadURL(imageRef);
        let thumbnailUrl = null;
        if (toThumbnailStorage) {
            try {
                const thumbnailRef = ref(Common.firebase.storage, toThumbnailStorage);
                thumbnailUrl = await getDownloadURL(thumbnailRef);
            }
            catch (e) {
                console.log(Common.res.errorGetThumbnailUrl + Common.getError(e));
            }
        }
        return { image: downloadUrl, thumbnail: thumbnailUrl };
    }
    static buildImageUpload(elemId, elemThumbnailId = '') {
        const icon = photoaddicon;
        return `
<div id="${elemId}Div">
    <input id="${elemId}" type="hidden" onchange="lib.photoOnChange('${elemId}')"} />
    ${Common.iif(!!elemThumbnailId, `<input id="${elemThumbnailId}" type="hidden" />`, '')}
    <img id="img_${elemId}" style="width: 200px; vertical-align: middle;" />
    <button id="btn_${elemId}" onclick="lib.imageUploadOpen('${elemId}' ${Common.iif(!!elemThumbnailId, `, '${elemThumbnailId}'`, '')})" class="imagebutton">
        <img src="${icon}" style="height: 24px; width: 24px;" />
    </button>
</div>`;
    }
    static buildImageUploadElem(elemId, elemThumbnailId, src) {
        const icon = Common.isInStorage(src) ? photoicon : photoaddicon;
        return Common.elem('div', { id: `${elemId}Div` }, [
            Common.elem('input', { id: elemId, type: 'hidden', onchange: () => Common.photoOnChange(elemId), value: src }),
            elemThumbnailId ? Common.elem('input', { id: elemThumbnailId, type: 'hidden' }) : null,
            Common.elem('img', { id: `img_${elemId}`, style: 'width: 200px; vertical-align: middle;', src }),
            Common.elem('button', { id: `btn_${elemId}`, class: 'imagebutton', onclick: () => ImageUpload.imageUploadOpen(elemId, elemThumbnailId) }, Common.elem('img', { style: 'height: 24px; width: 24px;', src: icon })),
        ]);
    }
}
ImageUpload.imageUploadElem = null;
ImageUpload.imageThumbnailElem = null;
